module.exports = __webpack_public_path__ + "img/jk1.56144fce.png";